<template>
  <div style="max-width: max-content">
    <a href="https://diabete.qc.ca" class="d-none d-md-inline"> <v-img src="@/assets/logo.jpg" contain></v-img></a>
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>